import styled from "@emotion/styled";
import { outlinedInputClasses } from "@mui/material";

export const ClickableFieldWrapper = styled("div", {
  shouldForwardProp: prop => prop !== "clickable"
})`
  width: 100%;

  ${({ clickable }) => clickable && `
    cursor: pointer;

    & .${outlinedInputClasses.root},
    & .${outlinedInputClasses.root}:hover,
    & .${outlinedInputClasses.input},
    & .${outlinedInputClasses.input}:hover {
      cursor: pointer !important;
    }
  `}
`;
